"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EMRA_ATTACHMENT_KINDS () {
        return _result.EMRA_ATTACHMENT_KINDS;
    },
    get EMRA_CHECKSUM_PATTERN () {
        return _result.EMRA_CHECKSUM_PATTERN;
    },
    get EMRA_LAB_RESULTS_PAGE_MAX_BYTES () {
        return _page.EMRA_LAB_RESULTS_PAGE_MAX_BYTES;
    },
    get EMRA_LAB_RESULTS_PAGE_MAX_ITEMS () {
        return _page.EMRA_LAB_RESULTS_PAGE_MAX_ITEMS;
    },
    get EMRA_PATIENT_NAME_MAX_LENGTH () {
        return _result.EMRA_PATIENT_NAME_MAX_LENGTH;
    },
    get EMRA_RESULT_MAX_ATTACHMENTS () {
        return _result.EMRA_RESULT_MAX_ATTACHMENTS;
    },
    get EMRA_RESULT_SUMMARY_MAX_LENGTH () {
        return _result.EMRA_RESULT_SUMMARY_MAX_LENGTH;
    },
    get EMRA_TEST_NAME_MAX_LENGTH () {
        return _result.EMRA_TEST_NAME_MAX_LENGTH;
    },
    get EmraChecksumSchema () {
        return _result.EmraChecksumSchema;
    },
    get EmraLabResultAttachmentV1Schema () {
        return _result.EmraLabResultAttachmentV1Schema;
    },
    get EmraLabResultResponseV1Schema () {
        return _result.EmraLabResultResponseV1Schema;
    },
    get EmraLabResultV1Schema () {
        return _result.EmraLabResultV1Schema;
    },
    get EmraLabResultsPageV1Schema () {
        return _page.EmraLabResultsPageV1Schema;
    },
    get EmraMatchKeysV1Schema () {
        return _result.EmraMatchKeysV1Schema;
    },
    get EmraMatchRefSchema () {
        return _result.EmraMatchRefSchema;
    },
    get EmraOemPatientRefSchema () {
        return _result.EmraOemPatientRefSchema;
    },
    get EmraPatientDetailsV1Schema () {
        return _result.EmraPatientDetailsV1Schema;
    },
    get EmraResultIdSchema () {
        return _result.EmraResultIdSchema;
    },
    get EmraUtcDateTimeSchema () {
        return _result.EmraUtcDateTimeSchema;
    },
    get SourceOemSchema () {
        return _result.SourceOemSchema;
    }
});
const _result = require("./result");
const _page = require("./page");
